import '@fortawesome/fontawesome-free/css/all.min.css';
import axios from 'axios';
import { useState } from "react";
import { Link } from 'react-router-dom';
import './login.css';

const Register = () => {
    const [formData, setFormData] = useState({
        username: '',
        email: '',
        password: '',
        confirmPassword: ''
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const FinalSubmit = async (e) => {
        e.preventDefault();
        if (formData.password !== formData.confirmPassword) {
            alert("Passwords do not match!");
            return;
        }

        // Object to store the form data before clearing
        const userData = {
            username: formData.username,
            email: formData.email,
            password: formData.password
        };
        try {
            await axios.post('http://localhost:9000/SignUp', userData);
            alert('User registered successfully!');
            
            // Log the user data object
            console.log('Stored user data:', userData);

            // Reset the form after submission
            setFormData({
                username: '',
                email: '',
                password: '',
                confirmPassword: ''
            });
        } catch (error) {
            alert('Registration failed! ' + (error.response?.data || error.message));
        }
    };

    return (
        <div className="container">
            <div className="screen">
                <div className="screen__content">
                    <form className="login" onSubmit={FinalSubmit}>
                        <div className="login__field">
                            <i className="login__icon fas fa-user"></i>
                            <input 
                                type="text"
                                name="username"
                                className="login__input"
                                placeholder="Enter your name"
                                value={formData.username}
                                onChange={handleChange}
                                required
                                autoComplete="username"
                            />
                        </div>
                        <div className="login__field">
                            <i className="login__icon fas fa-envelope"></i>
                            <input 
                                type="email"
                                name="email"
                                className="login__input"
                                placeholder="Enter your email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                autoComplete="email"
                            />
                        </div>
                        <div className="login__field">
                            <i className="login__icon fas fa-lock"></i>
                            <input 
                                type="password"
                                name="password"
                                className="login__input"
                                placeholder="Password"
                                value={formData.password}
                                onChange={handleChange}
                                required
                                autoComplete="new-password"
                            />
                        </div>
                        <div className="login__field">
                            <i className="login__icon fas fa-lock"></i>
                            <input 
                                type="password"
                                name="confirmPassword"
                                className="login__input"
                                placeholder="Confirm Password"
                                value={formData.confirmPassword}
                                onChange={handleChange}
                                required
                                autoComplete="new-password"
                            />
                        </div>
                        <button className="button login__submit" type="submit">
                            <span className="button__text">Register</span>
                        </button>
                    </form>
                    <div className="login__register">
                        <br/>
                        <p>Already have an account? <br/><br/> <Link to="/">Log In</Link></p>
                    </div>
                </div>
                <div className="screen__background">
                    <span className="screen__background__shape screen__background__shape4"></span>
                    <span className="screen__background__shape screen__background__shape3"></span>
                    <span className="screen__background__shape screen__background__shape2"></span>
                    <span className="screen__background__shape screen__background__shape1"></span>
                </div>
            </div>
        </div>
    );
};

export default Register;
